<script>
import { BNavItem } from 'bootstrap-vue'

export default {
  extends: BNavItem,
}
</script>
